<app-post *ngFor="let item of data" [data]="item"></app-post>
